import React, { useContext } from "react";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { useLatestQuery } from "../../../WSUtils/useLatestQuery";
import { useLocStore } from "../../../wsLocalization";
import { LocContext } from "../../../wsLocalization/LocContext";
import { getRedirectProps } from "../../../WSUtils/urlUtils";

export const AuthInfo = () => {
  const userInfo = useContext(UserInfoContext);
  const L = useLocStore(LocContext.PROFILE);

  const { data: whoAmi } = useLatestQuery(["authAPI.whoAmi"], () =>
    userInfo.fullAPI.authAPI.whoAmi({ includeUnitIds: false, userInfo })
  );

  return (
    <div>
      <span>
        {L.id("1502af8882bb").split(
          "Du er logget inn med Visma-Connect bruker {0}.",
          [whoAmi.name]
        )}
      </span>{" "}
      <a
        {...getRedirectProps("/logout", {
          userInfo,
          mergeQs: null,
        })}
        className="p-button-primary"
      >
        {L.id("783eee3c4596").loc("Logg ut")}
      </a>
    </div>
  );
};
